import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import config from '../functions/config';
import { Link } from "react-router-dom";

function PurchaseHistoryPage() {
  const [purchaseHistory, setPurchaseHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const sessionId = Cookies.get('sessionid');
    console.log("Session ID:", sessionId);

    // Check if the session ID exists, indicating the user is logged in
    if (sessionId) {
      fetchPurchaseHistory(sessionId);
    } else {
      setError('User not authenticated. Please log in.');
      setLoading(false);
    }
  }, []);

  const fetchPurchaseHistory = async (sessionId) => {
    try {
      const response = await axios.get(`${config.BASE_URL}/api/purchasehistory/`, {
        headers: {
          'X-Session-ID': sessionId, // Include session ID in the request headers
        },
      });

      if (response.status === 200) {
        const data = response.data;

        // Check if the purchase history is empty
        if (data.length === 0) {
          setPurchaseHistory([]); // Set an empty array for no purchase history
          setError(null); // Clear any existing error
        } else {
          setPurchaseHistory(data); // Set the retrieved purchase history
          setError(null); // Clear any existing error
        }
      } else {
        throw new Error('Failed to fetch purchase history.');
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Handle unauthorized access error
        setError('Unauthorized access. Please log in again.');
      } else {
        // Handle general errors
      }
    } finally {
      setLoading(false); // Stop the loading indicator
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div>
      {/* Fixed Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div className="container-fluid">
        {/* Brand Name */}
        <Link className="navbar-brand" to="/">
          📚 Library 
        </Link>

        {/* Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible Menu */}
        <div className={`navbar-collapse ${isOpen ? "show" : "collapse"}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/success">
                Books
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/userhome">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/profile">
                Profile
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/rentalhistory">
                Rented Books
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/purchasehistory">
                Purchase History
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/login" className="btn btn-danger">
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

      {/* Purchase History Table */}
      <div className="my-5 pt-5 container" style={{ marginTop: '80px' }}>
        <h2 className="text-center mb-4">Purchase History</h2>
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead className="table-dark">
              <tr>
                <th>Book</th>
                <th>Quantity</th>
                <th>Total Price</th>
                <th>Purchase Date</th>
                <th>Address</th>
                <th>Phone Number</th>
              </tr>
            </thead>
            <tbody>
              {purchaseHistory.length > 0 ? (
                purchaseHistory.map((purchase, index) => (
                  <tr key={index}>
                    <td>{purchase.book}</td>
                    <td>{purchase.quantity}</td>
                    <td>Rs. {purchase.total_price}</td>
                    <td>{new Date(purchase.purchase_date).toLocaleDateString()}</td>
                    <td>{purchase.address}</td>
                    <td>{purchase.phone_number}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center' }}>
                    No Purchase History Available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default PurchaseHistoryPage;
